import React from 'react'
import backArrow from "../assets/Images/backArrow.png"
const Header = () => {
  return (
    <div className='shadowline mb-21 mt-21 sticky-header'>
       <div className='pb-44 pl-20'>
       <img src={backArrow} width={9} height={17} className='mr-33 ' alt='backbtn' />
       <span className='headertitle'>Check Eligibility</span>
       </div>
    </div>
  )
}

export default Header
